import useUserStore from "stores/user"
import _sortBy from "lodash/sortBy"

const COMPANY_MANAGEMENT_CHILDREN = _sortBy(
  [
    {
      key: "trucks",
      label: "Trucks",
      adminOnly: true,
      url: "/trucks",
      parentKey: "company-management-menu",
    },
    {
      key: "trailers",
      label: "Trailers",
      adminOnly: true,
      url: "/trailers",
      parentKey: "company-management-menu",
    },
    {
      key: "users",
      label: "Users",
      isTitle: false,
      url: "/drivers",
      parentKey: "company-management-menu",
    },
    // {
    //   key: "customer-groups",
    //   label: "Customer Groups",
    //   isTitle: false,
    //   url: "/customer-groups",
    //   parentKey: "company-management-menu",
    // },
    {
      key: "groups",
      label: "Groups",
      isTitle: false,
      url: "/groups",
      parentKey: "company-management-menu",
    },
    {
      key: "common-carriers",
      label: "Common Carriers",
      isTitle: false,
      adminOnly: true,
      url: "/common-carriers",
      parentKey: "company-management-menu",
    },
    {
      key: "customers",
      label: "Customers",
      // url: "/new_customer_page",
      url: "/customers",
      hideForExternal: true,
      adminOnly: true,
      parentKey: "company-management-menu",
    },
    {
      key: "freight-bills-setup",
      adminOnly: true,
      label: "Freight Bills Setup",
      url: "/freight_billing_setup",
      parentKey: "company-management-menu",
    },
    {
      key: "driver-pay-rate",
      label: "Driver Pay Rate Setup",
      adminOnly: true,
      url: "/driver_pay_setup",
      parentKey: "company-management-menu",
    },
    {
      key: "loading_numbers",
      label: "Loading Numbers",
      adminOnly: true,
      url: "/loading_numbers",
      parentKey: "company-management-menu",
    },
    {
      key: "products",
      label: "Products",
      adminOnly: true,
      url: "/products",
      parentKey: "company-management-menu",
    },
    {
      key: "tax",
      adminOnly: true,
      label: "Tax Setup",
      url: "/tax",
      parentKey: "company-management-menu",
    },
    {
      key: "suppliers",
      adminOnly: true,
      label: "Suppliers",
      url: "/suppliers",
      parentKey: "company-management-menu",
    },
    {
      key: "terminals",
      adminOnly: true,
      label: "Terminals",
      url: "/terminals",
      parentKey: "company-management-menu",
    },
    {
      key: "contracts-management",
      label: "Contract Management",
      hideForCC: true,
      showForCustomer: true,
      url: "/contracts",
      parentKey: "company-management-menu",
    },
  ],
  (item: any) => item.label
)

export type MenuItemType = {
  key: string
  hide?: boolean
  label: string
  isTitle?: boolean
  hideForCC?: boolean
  hideForAnyCC?: boolean
  showForCustomer?: boolean
  hideForExternal?: boolean
  showDriver?: boolean
  adminOnly?: boolean
  priceOnly?: boolean
  icon?: string
  onClick?: any
  url?: string
  badge?: {
    variant: string
    text: string
  }
  parentKey?: string
  target?: string
  children?: MenuItemType[]
}
const getMenuItemsWithFlags = (flags: any) => {
  const hideLinks = useUserStore.getState()?.hideLinks
  const hasPricePermission = useUserStore.getState()?.hasPricePermission
  const isCustomer = useUserStore.getState()?.isCustomer

  const { driverLocationUpdateEnabled, showBestBuy } = flags || {}

  const MENU_ITEMS: MenuItemType[] = [
    {
      key: "dispatch-center",
      label: "Dispatch Center",
      isTitle: false,
      showDriver: true,
      icon: "ri-home-line",
      url: "/",
    },
    {
      key: "dispatching-views",
      label: "Dispatching Views",
      hideForCC: true,
      showForCustomer: true,
      showDriver: true,
      hideForAnyCC: true,
      isTitle: false,
      icon: "ri-list-unordered",
      children: [
        {
          key: "daily-driver-schedule",
          showForCustomer: true,
          showDriver: true,
          label: "Daily Driver Schedule",
          url: "/",
          parentKey: "dispatching-views",
        },
        {
          key: "load-list",
          showForCustomer: false,
          showDriver: true,
          label: "Load List",
          url: "/loads",
          parentKey: "dispatching-views",
        },
        {
          key: "load-tracking",
          showDriver: true,
          showForCustomer: false,
          label: "Load Tracking",
          url: "/tracking",
          parentKey: "dispatching-views",
        },
        {
          key: "mobile-fueling",
          showDriver: true,
          showForCustomer: false,
          label: "Mobile Fueling",
          url: "/mobile-fueling",
          parentKey: "dispatching-views",
        },
        {
          key: "scheduled-loads",
          showDriver: true,
          showForCustomer: false,
          label: "Scheduled Loads",
          url: "/scheduled-loads",
          parentKey: "dispatching-views",
        },
      ],
    },
    // {
    //   key: "load-list",
    //   label: "Load List",
    //   isTitle: false,
    //   icon: "ri-list-unordered",
    //   url: "/loads",
    // },
    // {
    //   key: "tracking",
    //   label: "Load Tracking",
    //   isTitle: false,
    //   icon: "ri-record-circle-line",
    //   url: "/tracking",
    // },
    {
      key: "map-view",
      hide: !driverLocationUpdateEnabled,
      label: "Map View",
      isTitle: false,
      hideForAnyCC: true,
      icon: "ri-map-pin-2-line",
      url: "/map-view",
    },
    {
      key: "reports",
      label: "Reports",
      hideForCC: true,
      showForCustomer: true,
      hideForAnyCC: true,
      isTitle: false,
      icon: "ri-line-chart-line",
      children: [
        {
          key: "driver-hours",
          showDriver: true,
          showForCustomer: false,
          label: "Driver Hours",
          url: "/driver-hours",
          parentKey: "reports",
        },
        {
          key: "pre-post-trip-reports",
          showDriver: true,
          showForCustomer: false,
          label: "Pre/Post Trip Reports",
          url: "/pre-post-trip-reports",
          parentKey: "reports",
        },
        {
          key: "search",
          showForCustomer: true,
          label: "Search",
          url: "/deliveries/",
          parentKey: "reports",
        },
        {
          key: "scorecard",
          showForCustomer: true,
          adminOnly: true,
          priceOnly: true,
          label: "Scorecard",
          url: "/scorecard/",
          parentKey: "reports",
        },
        {
          key: "site-export",
          showForCustomer: true,
          hideForAnyCC: true,
          label: "Site Export",
          url: "/site-export/",
          parentKey: "reports",
        },
      ],
    },
    {
      key: "inventory",
      label: "Inventory Management",
      isTitle: false,
      hideForCC: true,
      showForCustomer: true,
      icon: "ri-contrast-drop-2-line",
      url: "/inventory",
    },
    {
      hide: !showBestBuy && (!hasPricePermission || !isCustomer),
      key: "supply-management",
      label: "Supply Management",
      isTitle: false,
      hideForCC: true,
      hideForAnyCC: true,
      showForCustomer: hasPricePermission,
      icon: "ri-store-line",
      children: [
        {
          key: "supply-overview",
          label: "Supply Overview",
          url: "/supply-management/overview",
          parentKey: "supply-management",
        },
        {
          key: "pricing",
          label: "Pricing Import",
          url: "/pricing",
          parentKey: "supply-management",
        },
        {
          key: "custom-suppliers",
          label: "Custom Suppliers",
          hideForCC: true,
          adminOnly: true,
          url: "/custom_suppliers",
          parentKey: "supply-management",
        },
        // {
        //   key: "contract-allocation-tracking",
        //   label: "Contract Allocation Tracking",
        //   showForCustomer: true,
        //   url: "/contract_allocation",
        //   parentKey: "company-management-menu",
        // },
        {
          key: "email-notifications",
          label: "Pricing Email Queue",
          url: "/email-notifications",
          parentKey: "supply-management",
        },
        {
          key: "quotations",
          label: "Quoting",
          hideForExternal: true,
          url: "/quotations",
          parentKey: "supply-management",
        },
        {
          key: "quoting_history",
          label: "Quoting History",
          showForCustomer: hasPricePermission,
          url: "/quoting_history",
          parentKey: "supply-management",
        },
        {
          key: "planner",
          label: "Customer Location Best Buy",
          url: "/planner",
          parentKey: "supply-management",
        },
        {
          key: "arbitrage-map",
          label: "Arbitrage Map",
          url: "/supply-management/arbitrage-map",
          parentKey: "supply-management",
        },
      ],
    },
    {
      hide: hideLinks,
      key: "paperwork",
      label: "Paperwork",
      hideForCC: true,
      hideForAnyCC: true,
      showForCustomer: true,
      isTitle: false,
      icon: "ri-article-line",
      children: [
        // {
        //   key: 'loads-paperwork',
        //   label: 'Loads Paperwork',
        //   url: '/paperwork/',
        //   parentKey: 'paperwork'
        // },
        {
          key: "driver-pay",
          label: "Driver Pay",
          url: "/driver-pay",
          parentKey: "paperwork",
        },
        {
          key: "freight-bills",
          label: isCustomer ? "Completed Deliveries" : "Invoices",
          showForCustomer: true,
          url: "/freight_billing",
          parentKey: "paperwork",
        },
        {
          key: "reconciliation",
          label: "Reconciliation",
          url: "/reconciliation",
          parentKey: "paperwork",
        },
      ],
    },
    {
      hide: hideLinks,
      key: "company-management-menu",
      label: "Company Management",
      isTitle: false,
      icon: "ri-settings-4-line",
      children: COMPANY_MANAGEMENT_CHILDREN,
    },
    {
      key: "support",
      label: "Support",
      showDriver: true,
      isTitle: false,
      icon: "ri-lifebuoy-line",
      url: "",
      onClick: (e: any) => {
        window.location.href = "mailto:support@getdashfuel.com"
        e.preventDefault()
      },
    },
  ]
  return MENU_ITEMS
}
const getMenuItems = (flags: any) => {
  // NOTE - You can fetch from server and return here as well
  return getMenuItemsWithFlags(flags)
}

const findAllParent = (
  menuItems: MenuItemType[],
  menuItem: MenuItemType
): string[] => {
  let parents: string[] = []
  const parent = findMenuItem(menuItems, menuItem["parentKey"])

  if (parent) {
    parents.push(parent["key"])
    if (parent["parentKey"])
      parents = [...parents, ...findAllParent(menuItems, parent)]
  }

  return parents
}

const findMenuItem = (
  menuItems: MenuItemType[] | undefined,
  menuItemKey: MenuItemType["key"] | undefined
): MenuItemType | null => {
  if (menuItems && menuItemKey) {
    for (let i = 0; i < menuItems.length; i++) {
      if (menuItems[i].key === menuItemKey) {
        return menuItems[i]
      }
      const found = findMenuItem(menuItems[i].children, menuItemKey)
      if (found) return found
    }
  }
  return null
}

export { getMenuItems, findAllParent, findMenuItem }
